module.exports = __webpack_public_path__ + "img/code_start_tesseract.557f9dc3.png";